<template>
    <div style="height: 100%;overflow: auto;">
        <van-list v-model="loadinglog" :finished="finishedlog" finished-text="没有更多了">
            <el-card class="box-card mycard" v-for="(item,key) in beautyXfLog" :key="key" style="margin-bottom: 10px;">
                <div slot="header" style="background-color: rgb(238, 241, 246)" >
                    {{$moment(item.accountdate).format('YYYY-MM-DD')}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.cardTransactionHistories[0].cardnumber}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.cardTransactionHistories[0].membername}}
                  <div v-for="(val,index) in item.cardTransactionHistories" :key="index">
                      {{val.projectname}}
                  </div>
                </div>
                <el-form label-position="top" size="mini" @submit.native.prevent>
                    <el-form-item label="服务聊天内容">
                        <el-input type="textarea" v-model="item.beautyXfLog.chat" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>
                    <div style="margin-top: 5px;">
                        <van-button type="primary" color="#1989fa" size="large" @click="saveBeautyXfLog(item,0)" style="width: 60%;">保存</van-button>
                        <van-button type="primary" color="#1989fa" size="large" @click="saveBeautyXfLog(item,1)" style="width: 30%;float: right;">保存预约</van-button>
                    </div>
                </el-form>
            </el-card>
        </van-list>
    </div>
</template>
<script>
    export default {
      data() {
        return {
            brands:[],
            storeid:localStorage.getItem("storeid"),
            loadinglog:true,
            finishedlog:true,
            beautyXfLog:[],
            staffid:""
        }
    },
    created() {
        this.staffid=this.$route.query.staffid;
        if(!this.staffid){
            this.staffid=localStorage.getItem("staffid");
        }
        this.getNotXfLogCardtransHistory();
    },
    methods:{
        saveBeautyXfLog(item,type){
                if(!item.beautyXfLog.chat){
                    this.$message.error("请输入提升满意度当天做了什么");
                    return;
                }
                let beautyXfLog=new Object();
                beautyXfLog.storeid=item.cardTransactionHistories[0].storeid;
                beautyXfLog.cardid=item.cardTransactionHistories[0].cardid;
                beautyXfLog.memberid=item.cardTransactionHistories[0].memberid;
                beautyXfLog.accountdate=item.accountdate;
                beautyXfLog.oparation=item.beautyXfLog.oparation;
                beautyXfLog.xhtarget=item.beautyXfLog.xhtarget;
                beautyXfLog.chat=item.beautyXfLog.chat;
                beautyXfLog.nextdate=item.beautyXfLog.nextdate;
                let projectname="";
                for(let val of item.cardTransactionHistories){
                    if(projectname!=""){
                        projectname=projectname+","+val.projectname;
                    }
                    else{
                        projectname=val.projectname;
                    }
                }
                beautyXfLog.projectname=projectname;
                this.$postw("beautymanager/saveBeautyXfLog",beautyXfLog).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.getNotXfLogCardtransHistory();
                        if(type==1){
                            this.$router.push({path:"/beautyorder",query:{
                                cardid:item.cardTransactionHistories[0].cardid,
                                cardnumber:item.cardTransactionHistories[0].cardnumber,
                                memberid:item.cardTransactionHistories[0].memberid,
                                membername:item.cardTransactionHistories[0].membername,
                                memberphone:item.cardTransactionHistories[0].memberphone,
                                cardtypeid:item.cardTransactionHistories[0].cardtypeid,
                                sex:item.cardTransactionHistories[0].sex
                            }});
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
        },
        storeChange(val){
            localStorage.setItem("storeid",val);
            this.storeid=val;
            this.getNotXfLogCardtransHistory();
        },
        getNotXfLogCardtransHistory(){
            this.$post("beautymanager/getNotXfLogCardtransHistory",{storeid:localStorage.getItem("storeid"),staffid:this.staffid}).then(res=>{
                if(res.sucess){
                    this.beautyXfLog=res.object;
                }
                else{
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/page/beauty/beautyxflog.vue